import jQuery from 'jquery';

class SportSolutionApiWrapper {
  baseUrl() {
    return '/react';
  }

  constructor() {}

  login(callback) {
    this.request('POST', 'login', {}, function (resp) {
      if (callback) callback(resp);
    });
  }

  centers(callback) {
    this.request('GET', 'gyms', {}, function (resp) {
      if (callback) callback(resp);
    });
  }

  events(center_id, date, callback) {
    this.request('GET', 'events', {
      center_id: center_id,
      date: date
    }, function (resp) {
      if (callback) callback(resp);
    });
  }

  bookings(callback) {
    this.request('GET', 'participations/bookings', {}, function (resp) {
      if (callback) callback(resp);
    });
  }

  history(callback) {
    this.request('GET', 'history', {
      from_date: from_date,
      to_date: to_date
    }, function (resp) {
      if (callback) callback(resp);
    });
  }

  cancel(participation_id, callback, error_callback) {
    this.request('DELETE', `participations/${participation_id}`, {}, function (resp) {
      if (callback) callback(resp);
    }, function (error_resp) {
      if (error_callback) error_callback(error_resp);
    });
  }

  book(event_id, callback, error_callback) {
    this.request('POST', `events/${event_id}/book`, {}, function (resp) {
      if (callback) callback(resp);
    }, function (error_resp) {
      if (error_callback) error_callback(error_resp);
    });
  }

  schedule(category_id, schedule_id, callback, error_callback) {
    this.request('GET', `event_categories/${category_id}/event_schedules/${schedule_id}`, {}, function (resp) {
      if (callback) callback(resp);
    }, function (error_resp) {
      if (error_callback) error_callback(error_resp);
    });
  }

  participants(event_id, callback) {
    this.request('GET', `events/${event_id}`, {}, function (resp) {
        if (callback) callback(resp);
      },
      function (error_resp) {
        alert(error_resp.responseJSON.error);
      });
  }

  payDebtUrl() {
    return `${this.baseUrl()}/pay_debt`;
  }

  authorizeCardUrl() {
    return `${this.baseUrl()}/authorize_card`;
  }

  request(method, path, data, callback, error_callback) {
    const url = `${this.baseUrl()}/${path}`;
    jQuery.ajax({
      dataType: "json",
      url: url,
      data: data,
      method: method,
      success: callback,
      error: error_callback ? error_callback : callback
    });
  }
}

export default SportSolutionApiWrapper;
